import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home/index.vue'
import About from './views/About/index.vue'
import Contact from './views/Contact/index.vue'
import Download from './views/Download/index.vue'


import News from './views/News/index.vue'
import Detail from './views/Detail/index.vue'


Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [{
		path: '/',
		component: Home
	},{
		path: '/about',
		component: About
	},{
		path: '/contact',
		component: Contact
	},{
		path: '/download',
		component: Download
	},{
		path: '/news',
		component: News
	},{
		path: '/detail',
		component: Detail
	}]
})

